import { render, staticRenderFns } from "./pourquoi-miser-sur-le-contenu-evergreen-pour-booster-votre-seo.vue?vue&type=template&id=649f01f7&"
import script from "./pourquoi-miser-sur-le-contenu-evergreen-pour-booster-votre-seo.vue?vue&type=script&lang=js&"
export * from "./pourquoi-miser-sur-le-contenu-evergreen-pour-booster-votre-seo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports